/* jp-browse · library, series, search. Enhancement only (links, forms, <details> work without it). Replaces ux-128/132/133:
   topic chips feed the engine's filter term, the count follows its search events, the filter sheet gets Escape and
   scroll lock, "Show more" waits for the lazy engine, and the clicked card's picture is named for the zoom. */
(function () {
  'use strict';
  var d = document, each = function (s, f) { [].forEach.call(d.querySelectorAll(s), f); };
  function lib() { return d.querySelector('.jp-lib[data-jp-p0-root]'); }

  function count(r, n, busy) {
    var el = r.querySelector('[data-jp-library-result-count]');
    if (!el) return;
    if (el.dataset.orig == null) el.dataset.orig = el.textContent;
    if (busy) el.textContent = el.dataset.searching;
    else if (n == null) el.textContent = el.dataset.orig;
    else el.textContent = (r.jpLabel ? r.jpLabel + ' · ' : '') + (n === 1 ? el.dataset.one : el.dataset.other).replace(/\d[\d,]*/, n);
  }
  function state(r) {
    var q = r.querySelector('[data-jp-p0-search]'), on = !!((q && q.value.trim()) || r.dataset.jpLibraryFilterTerm);
    r.classList.toggle('jp-lib-searching', on);
    var c = r.querySelector('[data-jp-library-search-cancel]');
    if (c) c.hidden = !on;
    if (!on) count(r, null);
  }
  function topic(r, chip) {
    var term = chip.getAttribute('data-jp-library-filter') || '';
    r.dataset.jpLibraryFilterTerm = term;
    [].forEach.call(r.querySelectorAll('[data-jp-library-filter]'), function (c) {
      if (c.getAttribute('data-jp-library-filter') === term) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    r.jpLabel = term ? chip.getAttribute('data-label') || chip.textContent.trim() : '';
    state(r);
    r.dispatchEvent(new CustomEvent('justpress:library-filter-change', { bubbles: false }));
  }

  d.addEventListener('click', function (e) {
    var t = e.target, r = lib(), x;
    if (!t.closest) return;
    if (r && (x = t.closest('[data-jp-library-filter]')) && r.contains(x)) { e.preventDefault(); topic(r, x); return; }
    if (r && t.closest('[data-jp-library-search-cancel]')) {
      e.preventDefault();
      var q = r.querySelector('[data-jp-p0-search]');
      if (q) q.value = '';
      x = r.querySelector('[data-jp-library-filter=""]');
      if (x) topic(r, x); else { delete r.dataset.jpLibraryFilterTerm; state(r); }
      return;
    }
    if ((x = t.closest('[data-jp-browse-close]')) && (x = x.closest('details'))) { x.open = false; e.preventDefault(); return; }
    each('details[data-jp-browse-pop][open]', function (p) { if (!p.contains(t)) p.open = false; });
  });

  // "Show more designs" is a real link; while the engine is still lazy, load it and replay the click
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.jp-library-pagination__more'), L = window.JPFeatureLoader;
    if (!a || !L || L.isLoaded('p0') || a.dataset.jpWait) return;
    e.preventDefault();
    a.dataset.jpWait = '1';
    L.load('p0').then(function () { delete a.dataset.jpWait; a.click(); }, function () { location.href = a.href; });
  }, true);

  d.addEventListener('input', function (e) { var r = lib(); if (r && e.target.matches('[data-jp-p0-search]')) state(r); }, true);
  /* control centre 7.1 (10/16): sizes, sort, filter chips and the filter sheet keep the search words (?q=) */
  /* the box, or the address while the search engine is still loading and the box is not filled yet */
  var keepWordsLinks = '.jp-lib-sz a, .jp-lib-sort a, .jp-lib-active a, .jp-lib-fact a';
  function words(r) { var q = r && r.querySelector('[data-jp-p0-search], input[name="q"]'); return (q && q.value.trim()) || (new URLSearchParams(location.search).get('q') || '').trim(); }
  function keepWords(r, a) {
    var w = words(r); if (!w) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname) return;
    u.searchParams.set('q', w); a.href = u.pathname + u.search + u.hash;
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(keepWordsLinks), r = a && a.closest('.jp-library-page[data-jp-p0-root]');
    if (!r || e.defaultPrevented) return;
    keepWords(r, a);
  }, true);
  d.addEventListener('submit', function (e) {
    var f = e.target, r = f.closest && f.closest('.jp-library-page[data-jp-p0-root]');
    if (!r || !f.matches || !f.matches('[data-jp-library-facet-form]') || !r.contains(f)) return;
    var w = words(r), h = f.querySelector('input[name="q"]');
    if (!w) { if (h) h.remove(); return; }
    if (!h) { h = d.createElement('input'); h.type = 'hidden'; h.name = 'q'; h.setAttribute('data-jp-keep', ''); f.appendChild(h); }
    h.value = w;
  }, true);
  d.addEventListener('justpress:search-started', function () { var r = lib(); if (r) { state(r); count(r, 0, true); } });
  d.addEventListener('justpress:search-results-rendered', function (e) {
    var r = lib(), det = e.detail || {};
    if (det.appended) {
      each('.jp-library-page', function (root) {
        var p = root.querySelector('[data-jp-browse-showing]'), g = root.querySelector('[data-jp-p0-grid]'), pg = root.querySelector('.jp-lib-pages');
        if (p && g && p.dataset.tpl) p.textContent = p.dataset.tpl.replace('#', g.querySelectorAll('[data-jp-p0-card]').length + (+p.dataset.from || 1) - 1);
        if (pg) pg.hidden = true;
      });
    } else if (r) { state(r); count(r, r.classList.contains('jp-lib-searching') ? +det.count || 0 : null); }
  });

  // filter sheet (<details>): scroll lock and focus; Escape closes sheets and sort menus
  d.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('details[data-jp-browse-sheet]')) return;
    d.documentElement.classList.toggle('jp-browse-lock', t.open);
    var f = t.open ? t.querySelector('[role="dialog"]') : t.querySelector('summary');
    if (f) f.focus({ preventScroll: true });
  }, true);
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') each('details[data-jp-browse-sheet][open],details[data-jp-browse-pop][open]', function (x) { x.open = false; });
  });

  // zoom: the design page names its hero jp-hero too
  function clear() { each('[data-jp-vt]', function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-jp-vt'); }); }
  if ('viewTransitionName' in d.documentElement.style) {
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !e.target.closest) return;
      var a = e.target.closest('a[href]'), c = a && a.closest('.pin,.jp-library-card,.jp-ser-ci');
      var img = c && c.querySelector('a img');
      if (!img) return;
      clear();
      img.style.viewTransitionName = 'jp-hero';
      img.setAttribute('data-jp-vt', '');
    });
    addEventListener('pageshow', clear);
  }

  // deep links the lazy engine misses: ?search=open, #topic=
  function boot() {
    each('.jp-library-page[data-jp-p0-root]', function (root) {
      [].forEach.call(root.querySelectorAll(keepWordsLinks), function (a) { keepWords(root, a); });
    });
    var r = lib(), q = r && r.querySelector('[data-jp-p0-search]');
    if (!r) return;
    if (new URLSearchParams(location.search).get('search') === 'open' && q) q.focus();
    if (location.hash.indexOf('#topic=') === 0 && window.JPFeatureLoader) window.JPFeatureLoader.load('p0').catch(function () {});
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* "Show to scale" (prototype R26b): every design in the grid drawn at its real width against a 6 in card width,
   so a 1 × 1 in design looks small next to a 4 × 4 in one. Sizes come from each card's own size (custom.filter_size).
   The choice is remembered on this device only. */
(function () {
  'use strict';
  var b = document.querySelector('[data-jp-to-scale]');
  if (!b) return;
  var KEY = 'jp-to-scale';
  function get() { try { return localStorage.getItem(KEY) === '1'; } catch (_) { return false; } }
  function put(v) { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (_) {} }
  function inches(l) { var m = String(l || '').match(/([\d.]+)\s*[×x]\s*([\d.]+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
  function apply() {
    var on = b.getAttribute('aria-pressed') === 'true';
    document.documentElement.classList.toggle('jp-scaled', on);
    Array.prototype.forEach.call(document.querySelectorAll('[data-jp-p0-grid] .pin'), function (card) {
      var img = card.querySelector('.phl img'); if (!img) return;
      if (!on) { img.style.transform = ''; return; }
      var add = card.querySelector('[data-size]'), wh = inches(add && add.getAttribute('data-size'));
      if (!wh) { img.style.transform = ''; return; }
      var box = img.parentElement, W = box.clientWidth, H = box.clientHeight;
      var ar = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : (parseFloat(getComputedStyle(card).getPropertyValue('--ar')) || 1);
      var cw = W * 0.82, ch = H * 0.82; if (cw / ch > ar) cw = ch * ar;
      img.style.transform = 'scale(' + Math.min(1.2, (wh[0] / 6 * W) / cw).toFixed(3) + ')';
    });
  }
  b.addEventListener('click', function () { var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', on ? 'true' : 'false'); put(on); apply(); });
  if (get()) b.setAttribute('aria-pressed', 'true');
  window.addEventListener('resize', apply);
  window.addEventListener('load', apply);
  if ('MutationObserver' in window) {
    var g = document.querySelector('[data-jp-p0-grid]'), p = 0;
    if (g) new MutationObserver(function () { if (!p) p = requestAnimationFrame(function () { p = 0; apply(); }); }).observe(g, { childList: true });
  }
  apply();
})();

/* Series "Before you order" (prototype R26b): pick a size and the board redraws it at true proportion next to a
   credit card and a quarter, with this series' own design at that size; the caption gives Spaces, how many fit
   in the smallest pack and how many of the series' designs have that size (Shopify filter counts). */
(function () {
  'use strict';
  var board = document.querySelector('[data-jp-board]');
  if (!board) return;
  var sec = board.closest('section') || document;
  var cap = sec.querySelector('[data-jp-board-cap]'), capT = sec.querySelector('[data-jp-board-t]');
  var bx = board.querySelector('.bx'), card = board.querySelector('.rcard'), coin = board.querySelector('.rcoin');
  var cur = { w: parseFloat(board.getAttribute('data-w')) || 3, h: parseFloat(board.getAttribute('data-h')) || 3 };
  function desk() { return window.matchMedia('(min-width: 900px)').matches; }
  function sub(s, v) { s = String(s || ''); Object.keys(v).forEach(function (k) { s = s.split('%' + k).join(String(v[k])); }); return s; }
  function lay() {
    var W = board.clientWidth, H = board.clientHeight; if (!W) return;
    var CW = 3.37, CH = 2.125, CO = 0.955, pad = desk() ? 40 : 18, gap = desk() ? 0.9 : 0.5, w = cur.w, h = cur.h;
    var U = Math.min(desk() ? 64 : 46, (W - pad * 2) / (w + gap + CW), (H - pad * 2 - 26) / Math.max(h, CH + 0.75 + CO));
    var yB = H - pad - 22;
    bx.style.left = pad + 'px'; bx.style.top = (yB - h * U) + 'px'; bx.style.width = w * U + 'px'; bx.style.height = h * U + 'px';
    var cx = pad + (w + gap) * U;
    card.style.left = cx + 'px'; card.style.top = (yB - CH * U) + 'px'; card.style.width = CW * U + 'px'; card.style.height = CH * U + 'px';
    coin.style.left = (cx + CW * U - CO * U) + 'px'; coin.style.top = (yB - CH * U - 0.75 * U - CO * U) + 'px'; coin.style.width = CO * U + 'px'; coin.style.height = CO * U + 'px';
  }
  function pick(b) {
    var z = b.getAttribute('data-z'), m = z.match(/([\d.]+)\s*×\s*([\d.]+)/); if (!m) return;
    cur = { w: parseFloat(m[1]), h: parseFloat(m[2]) };
    Array.prototype.forEach.call(sec.querySelectorAll('[data-z]'), function (x) {
      var on = x === b; x.setAttribute('aria-pressed', on ? 'true' : 'false');
      var li = x.closest('li'); if (li) { li.classList.toggle('on', on); if (on) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current'); }
    });
    var img = bx.querySelector('img'), src = b.getAttribute('data-img') || board.getAttribute('data-first');
    if (src && img.getAttribute('src') !== src) img.src = src;
    bx.querySelector('span').textContent = z.replace(/ IN$/i, ' in').replace(/ × /g, ' × ');
    if (cap && capT) {
      var sp = Number(b.getAttribute('data-sp')) || 0, c = Number(cap.getAttribute('data-cap')) || 0, n = Number(b.getAttribute('data-n')) || 0;
      var parts = [sp === 1 ? cap.getAttribute('data-t-sp1') : sub(cap.getAttribute('data-t-sp'), { n: sp })];
      var up = window.JPSet ? (window.JPSet.tiers().filter(function (x) { return x.cap >= sp; })[0] || {}).cap : 0;
      if (sp && c) { if (sp <= c) parts.push(sub(cap.getAttribute('data-t-fit'), { n: Math.floor(c / sp) })); else if (up) parts.push(sub(cap.getAttribute('data-t-needs'), { n: up })); }
      if (n > 0) parts.push(sub(cap.getAttribute(n === 1 ? 'data-t-at1' : 'data-t-at'), { n: n }));
      capT.textContent = parts.join(' · ');
    }
    lay();
  }
  sec.addEventListener('click', function (e) { var b = e.target.closest('[data-z]'); if (b && sec.contains(b)) pick(b); });
  window.addEventListener('resize', lay);
  if ('ResizeObserver' in window) new ResizeObserver(lay).observe(board);
  lay();
})();

/* Series page 1 (prototype R26b): the set module sits inside the grid, after the first row on a computer and the
   first eight designs on a phone, spanning the full width. Without scripts it stays after the grid. */
(function () {
  'use strict';
  var set = document.querySelector('.jp-ser-set'), grid = document.querySelector('.jp-ser-grid[data-jp-p0-grid]');
  if (!set || !grid || /[?&]page=([2-9]|\d\d)/.test(location.search)) return;
  var mq = window.matchMedia('(min-width: 900px)');
  function unit() {
    var r = getComputedStyle(grid).gridAutoRows, px = parseFloat(r);
    return r && r !== 'auto' && px > 0 ? px : 0;
  }
  function fit() {
    var u = unit();
    set.style.gridRowEnd = u ? 'span ' + Math.ceil((set.offsetHeight + 40) / u) : '';
  }
  function place() {
    var cards = grid.querySelectorAll(':scope > .pin'), n = mq.matches ? 4 : 8;
    if (cards.length <= n) return;
    var after = cards[n - 1];
    if (set.previousElementSibling !== after || set.parentNode !== grid) after.insertAdjacentElement('afterend', set);
    set.classList.add('in-grid');
    fit();
  }
  place();
  if (mq.addEventListener) mq.addEventListener('change', place);
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
})();

/* Series introduction: since 2.2 it sits after the designs and shows in full, so the "Read more" button is gone and this does nothing. */
(function () {
  'use strict';
  var t = document.querySelector('[data-jp-intro]'), b = document.querySelector('[data-jp-intro-more]');
  if (!t || !b) return;
  t.classList.add('clamp');
  if (t.scrollHeight <= t.clientHeight + 2) { t.classList.remove('clamp'); return; }
  b.hidden = false;
  b.addEventListener('click', function () {
    var open = t.classList.toggle('clamp') === false;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = b.getAttribute(open ? 'data-less' : 'data-more');
  });
})();
